import psl from "psl";

// 机构归属库按可注册主域名（eTLD+1）建立索引。使用 Public Suffix List
// 解析 FQDN，避免手工维护多级公共后缀导致误判。
export function getRegistrableDomain(domain) {
  const normalized = String(domain || "").trim().toLowerCase().replace(/\.$/, "");
  if (!normalized || /^\d{1,3}(\.\d{1,3}){3}$/.test(normalized)) {
    return normalized;
  }

  const parsed = psl.parse(normalized);
  return parsed.domain || normalized;
}
